import cn from 'classnames';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import Image from 'next/image';
import { useRouter } from 'next/router';
import React from 'react';

import Button from 'components/basic/Button';
import { H1 } from 'components/basic/Typography';
import Page from 'components/layouts/Page';
import TwicePaymentInstructionsLink from 'components/pagesComponents/payments/PaymentSuccessPage/TwicePaymentInstructionsLink';

import { useAppSelector } from 'redux-store';

import s from './PaymentSuccessPage.module.scss';

export default function PaymentSuccessPage({
  title,
  footer,
  redirectUrl,
}: {
  title?: string | JSX.Element;
  footer?: string | JSX.Element;
  redirectUrl?: string;
}): JSX.Element {
  const t = useTranslationAndTypograph();
  const router = useRouter();
  const profileStore = useAppSelector(state => state.profile);
  const purchaseStore = useAppSelector(state => state.purchases);
  const { userAgent } = useAppSelector(state => state.ui);
  const isMobile = userAgent.device.type === 'mobile';
  const compact = router.query.compact as string | undefined;

  if (!footer) {
    const button = {
      href: redirectUrl || 'https://welltory.com',
    };
  
    const returnToApp = isMobile && compact;
    if (returnToApp) {
      button.href = 'welltory://action/web_payment?status=success';
    }
    
    footer = (
      <div className={s.linkToMainPages}>
        <Button
          className={s.linkToMainPage}
          look="rainbow"
          size="large"
          {...button}
        >
          {returnToApp ? t('start enjoying') : t('back to main page')}
        </Button>
      </div>
    );
  
    if (profileStore.isAuthenticated && purchaseStore.isFetched) {
      const { is_android_user, is_ios_user } = profileStore.profile;
  
      if (is_android_user || is_ios_user) {
        //todo если есть приложение
      }
  
      const mobileSubscriptionIndex = purchaseStore.purchases.findIndex(
        purchase => {
          return (
            purchase.payment_plan.payment_system === 1 ||
            purchase.payment_plan.payment_system === 2
          );
        },
      );
  
      if (mobileSubscriptionIndex !== -1) {
        const subscription = purchaseStore.purchases[mobileSubscriptionIndex];
  
        footer = (
          <TwicePaymentInstructionsLink
            paymentSystem={subscription.payment_plan.payment_system}
          />
        );
      }
    }
  }


  return (
    <Page>
      {title && (
        <H1
          className={cn('text-center mb-10 cy-success-page-title', {
            [s.title]: !!compact,
          })}
        >
          {title}
        </H1>
      )}
      <div className={s.imageWrapper}>
        <Image
          width={513}
          height={342}
          src="/pagesImages/payments/PaymentSuccessPage/success-payment.svg"
        />
      </div>

      {footer && footer}
    </Page>
  );
}
